export default "__VITE_ASSET__c4f2afe6__"